<tr>
  <td></td>
  <td></td>
  <td *ngIf="calculationResponse[0]?.gesamtAuflage"></td>
  <td *ngIf="calculationResponse[1]?.gesamtAuflage"></td>
  <td *ngIf="calculationResponse[2]?.gesamtAuflage"></td>
  <td></td>
</tr>
